import React from 'react';

var ArrowUpDown = function ArrowUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.11l4.72-4.924a.728.728 0 0 1 1.06 0 .807.807 0 0 1 0 1.107l-5.25 5.478a.728.728 0 0 1-1.06 0l-5.25-5.478a.807.807 0 0 1 0-1.107.728.728 0 0 1 1.06 0L12 19.11zm0-14.22L7.28 9.813a.728.728 0 0 1-1.06 0 .807.807 0 0 1 0-1.107l5.25-5.478a.728.728 0 0 1 1.06 0l5.25 5.478a.807.807 0 0 1 0 1.107.728.728 0 0 1-1.06 0L12 4.89z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowUpDown.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowUpDown as icon };
export default iconHandler(ArrowUpDown);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowUpDown.js
// module id = 584
// module chunks = 0